import { render, staticRenderFns } from "./FormSlot.vue?vue&type=template&id=f51620d8&scoped=true"
import script from "./FormSlot.vue?vue&type=script&lang=js"
export * from "./FormSlot.vue?vue&type=script&lang=js"
import style0 from "./FormSlot.vue?vue&type=style&index=0&id=f51620d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51620d8",
  null
  
)

export default component.exports